import React, { useState } from "react";
import { Close, DeleteOutlined, EditOutlined, SearchOutlined } from "@mui/icons-material";
import { Input, Modal } from "antd";
import { useSelector } from "react-redux";
import AddListModal from "./add-list";
import "./styles.scss";
import EditListModal from "./edit-list";
import DeleteListModal from "./delete-list";

function ManageLeadListModal({ preview, closeHandler, onDeleteHandler }) {
  // STATES
  const [searchText, setSearchText] = useState("");
  const [selectedData, setSelectedData] = useState(null);
  const [addPreview, setaddPreview] = useState(false);
  const [editPreview, setEditPreview] = useState(false);
  const [deletePreview, setdeletePreview] = useState(false);

  // REDUX DATA
  const list = useSelector((state) => state.LeadsListReducer.leadsList);

  // CONST VALS
  const managePreview = preview && !addPreview && !editPreview && !deletePreview;
  const defaultList = {
    id: "default",
    name: "General",
    default: true,
  };
  const filteredList = [defaultList, ...list].filter((item) =>
    item.name.toLowerCase().includes(searchText.toLowerCase())
  );

  // HANDLERS
  const addPreviewHandler = () => {
    setaddPreview(!addPreview);
  };

  const editPreviewHandler = (data) => {
    setSelectedData(data);
    setEditPreview(!editPreview);
  };

  const deletePreviewHandler = (data) => {
    setSelectedData(data);
    setdeletePreview(!deletePreview);
  };

  return (
    <>
      <Modal
        centered
        width={600}
        open={managePreview}
        onCancel={closeHandler}
        footer={null}
        closable={false}
        className="manage-leads-list-modal"
      >
        <div className="top-box">
          <h2>Manage Leads List</h2>
          <p>
            Manage your leads lists. You can create, edit, or delete lists to organize
            your leads effectively.
          </p>
          <button className="close-btn" onClick={closeHandler}>
            <Close />
          </button>
        </div>
        <div className="filter-box">
          <div className="search-box">
            <Input
              type="text"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              prefix={<SearchOutlined />}
              placeholder="Search lists"
            />
          </div>
          <button className="new-button" onClick={addPreviewHandler}>
            Create new list
          </button>
        </div>
        <ul>
          {filteredList.map((item) => (
            <li key={item.id}>
              {item.name}
              {item?.default ? (
                <span className="default-tag">Default</span>
              ) : (
                <span className="action-box">
                  <button className="edit-btn" onClick={() => editPreviewHandler(item)}>
                    <EditOutlined />
                  </button>
                  <button
                    className="delete-btn"
                    onClick={() => deletePreviewHandler(item)}
                  >
                    <DeleteOutlined />
                  </button>
                </span>
              )}
            </li>
          ))}
        </ul>
      </Modal>
      <AddListModal preview={addPreview} previewHandler={addPreviewHandler} />
      <EditListModal
        selectedData={selectedData}
        preview={editPreview}
        previewHandler={editPreviewHandler}
      />
      <DeleteListModal
        preview={deletePreview}
        successHandler={onDeleteHandler}
        previewHandler={deletePreviewHandler}
        selectedData={selectedData}
      />
    </>
  );
}

export default ManageLeadListModal;
